import { render, staticRenderFns } from "./DateRangeExt.vue?vue&type=template&id=1615a3c1&scoped=true&"
import script from "./DateRangeExt.vue?vue&type=script&lang=js&"
export * from "./DateRangeExt.vue?vue&type=script&lang=js&"
import style0 from "./DateRangeExt.vue?vue&type=style&index=0&id=1615a3c1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1615a3c1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1615a3c1')) {
      api.createRecord('1615a3c1', component.options)
    } else {
      api.reload('1615a3c1', component.options)
    }
    module.hot.accept("./DateRangeExt.vue?vue&type=template&id=1615a3c1&scoped=true&", function () {
      api.rerender('1615a3c1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2dbpPba5pKXu4/JS/comp/DateRangeExt.vue"
export default component.exports